'use strict';

import {financingRequestModel} from "@js/models/financingrequestmodel";
import {timeZoneDate} from "@js/lib/timezonedate";

export class PeriodicReportingCtrl {
    $scope;
    $filter;
    jsDataService;
    $mdDialog;
    classif;
    terminationDateUi;

    constructor($scope, $filter, jsDataService, $mdDialog) {
        'ngInject';
        this.$scope = $scope;
        this.$filter = $filter;
        this.jsDataService = jsDataService;
        this.$mdDialog = $mdDialog;
        this.classif = this.jsDataService.get('cfgClassif', {});

        this.setReport(this.jsDataService.get('reporting', {}));
        this.setChecklistPreview(this.jsDataService.get('checklistpreview', {}));
        this.terminationDateUi = this.report.termination_date || '';
    }

    setReport(report) {
        this.report = new financingRequestModel(report, this.$filter, this.jsDataService);
    }

    setChecklistPreview(raw) {
        if (!raw) {
            this.checklistPreview = null;
            return;
        }

        const ts = raw.confirmation_date;
        this.checklistPreview = {
            ...raw,
            confirmationDate: ts > 0
                ? new Date(ts * 1000)
                : null
        };
    }

    actPaid(ev) {
        const cfg = this.jsDataService.get('cfgPaid');
        this.$mdDialog.show({
            controller: ["$scope", "$mdDialog", "report", this.paidEditorDialogCtrl],
            templateUrl: 'projects/paid_editor.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true,
            locals: {
                report: this.report
            }
        }).then((results) => {
            if (cfg.saveUrl) {
                this.$scope.basicHttpConfigProcess({
                    url: cfg.saveUrl,
                    method: 'POST',
                    data: {
                        paid_date: this.$filter('date')(results.paid_date_cet, 'yyyy-MM-dd')
                    }
                }).then((response) => {
                    if (response.data.success) {
                        this.report.paid_date_cet = results.paid_date_cet;
                    }
                }, () => {
                });
            }
        }, () => {
        });
    }

    paidEditorDialogCtrl($scope, $mdDialog, report) {
        $scope.paid_date_cet;
        if (report.paid_date_cet instanceof Date) {
            $scope.paid_date_cet = new Date(report.paid_date_cet.getTime());
        } else {
            $scope.paid_date_cet = timeZoneDate(new Date(), 'CET');
        }

        $scope.close = function () {
            $mdDialog.cancel();
        };

        $scope.save = function () {
            $mdDialog.hide({
                paid_date_cet: $scope.paid_date_cet
            });
        };
    }

    go2Url(urlString) {
        this.$scope.goUrl(urlString);
    }

    actConfirmEdit(ev) {
        const confirmTexts = this.jsDataService.get('editConfirmTexts');
        const confirm = this.$mdDialog.confirm()
            .title(confirmTexts.title)
            .htmlContent(confirmTexts.content)
            .ariaLabel(confirmTexts.title)
            .targetEvent(ev)
            .ok(confirmTexts.ok)
            .cancel(confirmTexts.cancel);

        this.$mdDialog.show(confirm).then(() => {
            this.$scope.basicHttpConfigProcess({
                url: this.jsDataService.get('cfgEditConfirmUrl'),
                method: 'GET',
                params: {}
            }).then((results) => {
                if (results.data.success) {

                }
            });
        }, () => {
        });
    }

    getClassifValue(value, classifName) {
        if (this.classif && typeof (this.classif[classifName]) !== 'undefined') {
            let v = this.$filter('filter')(this.classif[classifName], {id: value}, true);
            if (v.length > 0) {
                return v[0].title;
            }
        }
        return '';
    }

    actConfirmResolution(ev) {
        const confirmTexts = this.jsDataService.get('resolutionConfirmTexts');
        const confirm = this.$mdDialog.confirm()
            .title(confirmTexts.title)
            .htmlContent(confirmTexts.content)
            .ariaLabel(confirmTexts.title)
            .targetEvent(ev)
            .ok(confirmTexts.ok)
            .cancel(confirmTexts.cancel);

        this.$mdDialog.show(confirm).then(() => {
            this.$scope.basicHttpConfigProcess({
                url: this.jsDataService.get('cfgResolutionConfirmUrl'),
                method: 'GET',
                params: {}
            }).then((results) => {
                if (results.data.success) {

                }
            });
        }, () => {
        });
    }

    actConfirmObservations(ev) {
        const confirmTexts = this.jsDataService.get('observationsConfirmTexts');
        const confirm = this.$mdDialog.confirm()
            .title(confirmTexts.title)
            .htmlContent(confirmTexts.content)
            .ariaLabel(confirmTexts.title)
            .targetEvent(ev)
            .ok(confirmTexts.ok)
            .cancel(confirmTexts.cancel);

        this.$mdDialog.show(confirm).then(() => {
            this.$scope.basicHttpConfigProcess({
                url: this.jsDataService.get('cfgobservationsConfirmUrl'),
                method: 'GET',
                params: {}
            }).then((results) => {
                if (results.data.success) {

                }
            });
        }, () => {
        });
    }

    openTerminationDialog(ev) {
        const saveUrl = this.jsDataService.get('cfgBalanceSaveUrl', '');

        this.$mdDialog.show({
            controller: [
                "$rootScope",
                "$scope",
                "$mdDialog",
                "$filter",
                "report",
                "saveUrl",
                this.terminationDialogCtrl
            ],
            templateUrl: 'projects/termination_date_editor.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true,
            locals: {
                report: this.report,
                saveUrl: saveUrl
            }
        }).then((results) => {
            if (results && results.termination_date) {
                this.report.termination_date = results.termination_date;
            }
        }, () => {
        });
    }


    terminationDialogCtrl($rootScope, $scope, $mdDialog, $filter, report, saveUrl) {

        $scope.terminationForm = null;

        $scope.terminationValue = {
            termination_date_cet: null
        };

        if (report.termination_date instanceof Date) {
            $scope.terminationValue.termination_date_cet = new Date(report.termination_date.getTime());
        } else if (report.termination_date) {
            $scope.terminationValue.termination_date_cet = new Date(report.termination_date);
        } else {
            $scope.terminationValue.termination_date_cet = new Date();
        }

        $scope.close = function () {
            $mdDialog.cancel();
        };

        $scope.save = function () {
            const dateForBackend = $filter('date')(
                $scope.terminationValue.termination_date_cet,
                'yyyy-MM-dd'
            );

            $rootScope.basicHttpConfigProcess({
                url: saveUrl,
                method: 'POST',
                data: {
                    termination_date: dateForBackend
                }
            }).then(function (response) {
                if (response.data && response.data.success) {
                    $mdDialog.hide({
                        termination_date: response.data.termination_date || dateForBackend
                    });
                }
            }, () => {
            });
        };
    }

}
